module.exports = __webpack_public_path__ + "static/img/img_awards_5.8d78157.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/aboutUs/img_awards_5.png
// module id = mnXp
// module chunks = 15